import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-CDesign";
import leftimgs from "../../../assets/Scratchleftimg.png";
import rightimgs from "../../../assets/Scratchrightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/Scratch-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/Scratch-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/Scratch-benefit-img3.png";
import BenefitsDataImg4 from "../../../assets/Scratch-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/Scratch-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/Scratch-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/Scratch-benefit-img7.png";
import BenefitsDataImg8 from "../../../assets/Scratch-benefit-img8.png";
import BenefitsDataImg9 from "../../../assets/Scratch-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/ScratchFun-img1.png";
import FunactivitiesImg2 from "../../../assets/ScratchFun-img2.png";
import FunactivitiesImg3 from "../../../assets/ScratchFun-img3.png";
import FunactivitiesImg4 from "../../../assets/ScratchFun-img4.png";
import FunactivitiesImg5 from "../../../assets/ScratchFun-img5.png";
import LearningStyle from "../../../MyComponents/LearningStyle"
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";

import Testimonials from "../../../MyComponents/Testimonials";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "11",
      classes: "06",
      description: "Animation Fundamentals – Learn coding through fun games and Scratch Jr animations using loops and logic.",
    },
    {
      title: "Module 2",
      activities: "11",
      classes: "06",
      description: " Scratch Programming Interface – Explore M-Block, create text animations, backgrounds, and fun cartoon characters.",
    },
    {
      title: "Module 3",
      activities: "11",
      classes: "06",
      description:" Animation Programming – Create fun stories, move objects, and build exciting animations.",
    },
    
  ];

  const advancedModules = [
    {
      title: "Module 1",
      activities: "11",
      classes: "06",
      description:" Game Designing – Build exciting games using conditions, loops, color sensing, object detection, and cloning.",
    },
    {
      title: "Module 2",
      activities: "11",
      classes: "12",
      description:" AI Fundamentals – Learn basics of AI with training, testing, loops, and conditions using ML for Kids.",
    },
    {
      title: "Module 3",
      activities: "11",
      classes: "12",
      description:
        " AI Advance – Explore advanced ML concepts and learn to add extensions on the ML platform.",
    },
   
  ];


  const benefitsData = [
      {
        title: "Code Games & Apps",
        description: "Design and develop interactive games and applications.",
        icon: "Polymath-images/Scratch-benefit-img1.png", //ji
      },
      {
        title: "Develop Persistence",
        description: "Develop persistence by overcoming challenges in problem-solving tasks.",
        icon: "Polymath-images/Scratch-benefit-img2.png",
      },
      {
        title: "Learn Coding with Scratch",
        description: "Code games, boost logic, spark creativity, and build future-ready skills.",
        icon: "Polymath-images/Scratch-benefit-img3.png",
      },
      {
        title: "Spark imagination",
        description: "Encourage creative thinking and exploration in the digital world.",
        icon: "Polymath-images/Scratch-benefit-img4.png",
      },
      {
        title: "Use Logic & Expression",
        description: "Understand and apply logical thinking and creative expression in coding.",
        icon: "Polymath-images/Scratch-benefit-img5.png",
      },
      {
        title: "Improve digital literacy",
        description: "Gain foundational digital skills for navigating the tech-driven world.",
        icon: "Polymath-images/Scratch-benefit-img6.png",
      },
      {
        title: "Gain career-ready skills",
        description: "Build a solid foundation of skills that are highly valuable in the tech industry.",
        icon: "Polymath-images/Scratch-benefit-img7.png",
      },
      {
        title: "Sharpen Math & Thinking Skills",
        description: "Improve mathematical understanding and logical reasoning through coding exercises.",
        icon: "Polymath-images/Scratch-benefit-img8.png",
      },
      {
        title: "Build confidence  & communication",
        description: "Build confidence and communication through teamwork.",
        icon: "Polymath-images/Scratch-benefit-img9.png",
      },
    ];
    const activitiesData = [
        {
          title: "Ping Pong Game",
          image: "Polymath-images/ScratchFun-img1.png",
        },
        {
          title: "Snake Game",
          image: "Polymath-images/ScratchFun-img2.png",
        },
        {
          title: "Eid Card Game",
          image: "Polymath-images/ScratchFun-img3.png",
        },
        {
          title: "Fish Game",
          image: "Polymath-images/ScratchFun-img4.png",
        },
        {
          title: "Jumping Game",
          image: "Polymath-images/ScratchFun-img5.png",
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "", // Replace with the actual video URL
  };
const ScratchProgramming = () => {
  const Scratchpage = heroContent.scratchsection;
  return (
    <>
       {/* <GuestNav/> */}
    <HeadSection
      leftImg={'Polymath-images/Scratchleftimg.png'}
      rightImg={'Polymath-images/Scratchrightimg.png'}
      titlePart1="Scratch Programming "
      titlePart2="Course"
      description="Polymath-kids offer comprehensive online Scratch programming course, a block-based programming language for kids. The online coding classes’ offers two modes -online 1:1 classes and online group classes with trained teachers having years of experience in Computer Sciences."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={'Polymath-images/pencil.png'}
      button2Icon={'Polymath-images/pencil.png'}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
              title1="Course Structure & Syllabus"
              title="Beginner Level Course"
              modules={beginnerModules}
            />
            <CourseTimeline
             
              title="Advance Level Course"
              modules={advancedModules}
            />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Kidprenur Course"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default ScratchProgramming;